<template>
    <div>
        <div
            v-for="item in downloadableItems"
            v-bind:key="item.attachmentId">
            <envelope-completed-item
                v-bind:item="item"
                v-bind:download-completed-item-fn="downloadCompletedItemFn"
                v-bind:class="responsiveClasses.completedItem" />
        </div>
    </div>
</template>

<script>
    import envelopeCompletedItem from "./envelopeCompletedItem.vue";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        completedItem: {
            always: "mt-2"
        }
    };

    export default {
        components: {
            envelopeCompletedItem
        },
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            envelope: { type: Object, required: false, default: null },
            showCertificate: { type: Boolean, required: false, default: false },
            downloadCompletedItemFn: { type: Function, required: true }
        },
        computed: {
            combinedDocumentName() {
                return this.getAttachmentFilename(this.envelope.TargetAttachmentId);
            },
            certificateDocumentName() {
                return this.getAttachmentFilename(this.envelope.CertificateTargetAttachmentId);
            },
            downloadableItems() {
                const items = [];
                if (this.envelope.TargetAttachmentId) {
                    const combinedDocumentItem = this.buildDownloadableItem(
                        this.combinedDocumentName,
                        this.envelope.TargetAttachmentId
                    );
                    items.push(combinedDocumentItem);
                }
                if (this.showCertificate && this.envelope.CertificateTargetAttachmentId) {
                    const certificateItem = this.buildDownloadableItem(
                        this.certificateDocumentName,
                        this.envelope.CertificateTargetAttachmentId
                    );
                    items.push(certificateItem);
                }

                for (const item of Object.values(this.envelope.Items).filter((i) => i.TargetAttachmentId)) {
                    const downloadableItem = this.buildDownloadableItemFromGeneratedDocItem(item);
                    items.push(downloadableItem);
                }
                return items;
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            }
        },
        methods: {
            buildDownloadableItem(name, attachmentId) {
                return {
                    name: name,
                    attachmentId: attachmentId
                };
            },
            buildDownloadableItemFromGeneratedDocItem(item) {
                const targetAttachmentFilename = this.getAttachmentFilename(item.TargetAttachmentId);
                return this.buildDownloadableItem(targetAttachmentFilename, item.TargetAttachmentId);
            },
            getAttachmentFilename(attachmentId) {
                const attachment = this.envelope.AttachmentsById[attachmentId];
                return attachment?.FileName ?? "";
            }
        }
    };
</script>
